import { refreshUserToken } from '../../Auth/refreshToken.js';
import { isAbortError } from '../../Auth/isAbortError.js';

export const SET_AUTH = 'SET_AUTH';
export const SET_ROLE = 'SET_ROLE';

export const setAuth = (isAuthenticated) => ({
    type: SET_AUTH,
    payload: isAuthenticated
});

export const setRole = (roleId) => ({
    type: SET_ROLE,
    payload: roleId
});

const SESSION_REFRESH_FLAG = 'authRefreshedThisSession';

export const checkAuth = (options = {}) => async (dispatch) => {
    const { signal } = options;
    const token = localStorage.getItem('userToken');
    dispatch(setAuth(!!token));

    const roleId = localStorage.getItem('roleId');
    if (roleId) {
        dispatch(setRole(roleId));
    }

    if (!token) {
        return;
    }

    if (sessionStorage.getItem(SESSION_REFRESH_FLAG)) {
        return;
    }

    sessionStorage.setItem(SESSION_REFRESH_FLAG, '1');

    try {
        await refreshUserToken(dispatch, { signal });
    } catch (error) {
        if (isAbortError(error)) {
            sessionStorage.removeItem(SESSION_REFRESH_FLAG);
        }
    }
};
